import React, { useEffect, useState } from 'react';
import {
  Box,
  ButtonWithAction,
  FormInput,
  Cluster,
  constants,
  FormSelect,
  Loading,
  util,
} from '@thecb/components';
import {
  reducer,
  mapStateToProps,
  mapDispatchToProps,
} from './DrawerHistoryFiltersForm.state';
import {
  maxAmountErrorsMessage,
  minAmountErrorsMessage,
} from '../../utils/filterFormsHelpers';
import { DrawerHistorySearchInput } from './DrawerHistorySearchInput';
import { AmtFilterContainer, SelectContainer } from '../../components/styled';
import DatePicker from '../../components/date-picker';

let DrawerHistoryFiltersForm = ({
  actions,
  fields,
  forms,
  showErrors,
  fetchData,
  terminalOptions = [],
  locationOptions = [],
  agencyOptions = [],
  userOptions = [],
  clear,
  shouldClear,
  loading,
}) => {
  const [, handleErrors] = useState(false);
  useEffect(() => {
    fetchData({ pageIndex: 1 });
  }, [
    fields.user.rawValue,
    fields.terminal.rawValue,
    fields.location.rawValue,
    fields.agency.rawValue,
  ]);
  const oneOrMoreActiveFilters = Object.entries(fields).some(
    ([_, { rawValue }]) => Boolean(rawValue),
  );
  const clearFilterForm = () => {
    actions.form.clear();
  };

  const handleFiltersSubmit = util.general.generateClickHandler(
    forms.drawerHistoryFiltersForm,
    () => handleErrors(true),
    () => fetchData({ pageIndex: 1 }),
  );

  return (
    <Box padding="0" as="form" onSubmit={handleFiltersSubmit}>
      {loading ? (
        <Loading />
      ) : (
        <>
          <DrawerHistorySearchInput
            actions={actions}
            fields={fields}
            searchErrors={showErrors}
            fetchData={fetchData}
            handleSubmit={handleFiltersSubmit}
            shouldClear={shouldClear}
            clear={clear}
          />
          <Box background={constants.colors.ATHENS_GREY}>
            <Cluster childGap="1rem" align="center" overflow="visible">
              <AmtFilterContainer>
                <FormInput
                  data-testid="Min Amount Test"
                  labelTextWhenNoError="Min Amount"
                  errorMessages={minAmountErrorsMessage}
                  field={fields.minAmount}
                  errors={fields.errors}
                  fieldActions={actions.fields.minAmount}
                  type={'number'}
                  labelTextVariant="p"
                  errorTextVariant="p"
                />
              </AmtFilterContainer>
              <AmtFilterContainer>
                <FormInput
                  data-testid="Max Amount Test"
                  labelTextWhenNoError="Max Amount"
                  errorMessages={maxAmountErrorsMessage}
                  field={fields.maxAmount}
                  errors={fields.errors}
                  fieldActions={actions.fields.maxAmount}
                  type={'number'}
                  labelTextVariant="p"
                  errorTextVariant="p"
                />
              </AmtFilterContainer>
              <DatePicker
                label="Start Date (mm/dd/yyyy)"
                id="drawer-history-start-date"
                field={fields.startDate}
                fieldActions={actions.fields.startDate}
              />
              <DatePicker
                label="End Date (mm/dd/yyyy)"
                id="drawer-history-end-date"
                field={fields.endDate}
                fieldActions={actions.fields.endDate}
              />
            </Cluster>
            <Cluster childGap="1rem" align="center" overflow="visible">
              <SelectContainer>
                <FormSelect
                  hasTitles
                  dropdownMaxHeight="200px"
                  data-testid="Agency Test"
                  labelTextWhenNoError="Agency"
                  options={agencyOptions}
                  fieldActions={actions.fields.agency}
                  showErrors={fields.errors}
                  field={fields.agency}
                  widthFitOptions
                  labelTextVariant="p"
                  errorLabelTextVariant="p"
                />
              </SelectContainer>
              <SelectContainer>
                <FormSelect
                  hasTitles
                  dropdownMaxHeight="200px"
                  data-testid="Location Test"
                  labelTextWhenNoError="Location"
                  options={locationOptions}
                  fieldActions={actions.fields.location}
                  showErrors={fields.errors}
                  field={fields.location}
                  widthFitOptions
                  labelTextVariant="p"
                  errorLabelTextVariant="p"
                />
              </SelectContainer>
              <SelectContainer>
                <FormSelect
                  hasTitles
                  dropdownMaxHeight="200px"
                  data-testid="Terminal Test"
                  labelTextWhenNoError="Terminal"
                  options={terminalOptions}
                  fieldActions={actions.fields.terminal}
                  showErrors={fields.errors}
                  field={fields.terminal}
                  widthFitOptions
                  labelTextVariant="p"
                  errorLabelTextVariant="p"
                />
              </SelectContainer>
              <SelectContainer>
                <FormSelect
                  hasTitles
                  dropdownMaxHeight="200px"
                  data-testid="User Test"
                  labelTextWhenNoError="User"
                  options={userOptions}
                  fieldActions={actions.fields.user}
                  showErrors={fields.errors}
                  field={fields.user}
                  widthFitOptions
                  labelTextVariant="p"
                  errorLabelTextVariant="p"
                />
              </SelectContainer>
            </Cluster>
            {oneOrMoreActiveFilters && (
              <ButtonWithAction
                type="reset"
                padding="0"
                margin="0"
                variant="smallGhost"
                action={clearFilterForm}
                text="Clear filters"
              />
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

DrawerHistoryFiltersForm.reducer = reducer;
DrawerHistoryFiltersForm.mapStateToProps = mapStateToProps;
DrawerHistoryFiltersForm.mapDispatchToProps = mapDispatchToProps;

export { DrawerHistoryFiltersForm };
